<template>
  <div>
    <Head :title="title" />
    <div class="mr-2 overflow-hidden bg-white rounded-md shadow">
        <form @submit.prevent="update">
        <div class="flex flex-wrap p-8 -mb-8 -mr-6">
            <text-input v-model="form.MAIL_HOST" :error="form.errors.MAIL_HOST" class="w-full pb-8 pr-6 lg:w-1/3" :label="__('Hôte SMTP')" />
            <text-input v-model="form.MAIL_PORT" :error="form.errors.MAIL_PORT" class="w-full pb-8 pr-6 lg:w-1/3" :label="__('Port SMTP')" />
            <text-input v-model="form.MAIL_USERNAME" :error="form.errors.MAIL_USERNAME" class="w-full pb-8 pr-6 lg:w-1/3" :label="__('Utilisateur')" />
            <text-input v-model="form.MAIL_PASSWORD" :error="form.errors.MAIL_PASSWORD" class="w-full pb-8 pr-6 lg:w-1/3" type="password" :label="__('Mot de passe')" />
            <text-input v-model="form.MAIL_ENCRYPTION" :error="form.errors.MAIL_ENCRYPTION" class="w-full pb-8 pr-6 lg:w-1/3" :label="__('Chiffrement')" />
            <text-input v-model="form.MAIL_FROM_ADDRESS" :error="form.errors.MAIL_FROM_ADDRESS" class="w-full pb-8 pr-6 lg:w-1/3" :label="__('E-mail expéditeur')" />
            <text-input v-model="form.MAIL_FROM_NAME" :error="form.errors.MAIL_FROM_NAME" class="w-full pb-8 pr-6 lg:w-1/3" :label="__('Nom expéditeur')" />
        </div>
            <div class="flex items-center px-8 py-4 border-t border-gray-100 bg-gray-50">
                <loading-button :loading="form.processing" class="ml-auto btn-indigo" type="submit">{{ __('Save') }}</loading-button>
            </div>
        </form>

    </div>
  </div>
</template>

<script>
import { Link, Head } from '@inertiajs/vue3'
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'
import Pagination from '@/Shared/Pagination'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import axios from 'axios'

export default {
  metaInfo: { title: 'Priorities' },
  components: {
    Icon,
    Link,
      Head,
    Pagination,
      TextInput,
      SelectInput,
      LoadingButton,
  },
  layout: Layout,
  props: {
      title: String,
      demo: Boolean,
      keys: Object,
  },
    remember: 'form',
  data() {
    return {
        form: this.$inertia.form({
            MAIL_HOST: this.demo?'******************':this.keys['MAIL_HOST']['value'],
            MAIL_PORT: this.keys['MAIL_PORT']['value'],
            MAIL_USERNAME: this.demo?'**********************':this.keys['MAIL_USERNAME']['value'],
            MAIL_PASSWORD: this.demo?'*********':this.keys['MAIL_PASSWORD']['value'],
            MAIL_ENCRYPTION: this.keys['MAIL_ENCRYPTION']['value'],
            MAIL_FROM_ADDRESS: this.keys['MAIL_FROM_ADDRESS']['value'],
            MAIL_FROM_NAME: this.keys['MAIL_FROM_NAME']['value'],
        }),
    }
  },
  methods: {
      update() {
          this.form.put(this.route('settings.smtp.update'), {
              onSuccess: () => {
                  axios.get(this.route('clear.cache','config')).then((response) => {})
              }
          })
      },
  },
    created() {
      console.log(this.demo)
    }
}
</script>
